var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwiperPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: "140%",
    height: "140%",
    x: "-20%",
    y: "-14.3%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M34.7764148,17.3867536 C34.5515747,15.6039388 33.2620337,12.1733877 33.0005784,10.3949479 C32.7190992,8.46174238 30.0908155,5.77439526 28.8624905,4.20431517 C26.968799,1.78165588 24.8834499,1.05048308 20.1612354,0.230716431 C17.936863,-0.154284053 15.6066499,-0.085377716 13.4801087,0.650170082 C11.1579051,1.45462422 8.17548395,2.82564156 4.54657599,4.75830024 C1.52181857,6.86814663 0,12.4276849 0,21.4522274 L0,23.0272294 C4.30571674,31.0039582 8.78306715,35.2854479 13.3988687,34.9852132 C15.0763018,34.8736505 19.0593472,34.3038061 21.31633,33.9685713 C22.401627,33.8072429 23.4834912,33.529977 24.491553,33.1138046 C33.559532,29.3950499 35.7844765,25.4602793 34.7764148,17.3867536"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "matrix(-1 0 0 1 39 2)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "#000",
    filter: "url(#b)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "#9CCB55"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.5153169,9.05913445 C16.8271596,8.89645737 16.8891737,9.06443914 17.3693405,9.62496779 C18.6982153,11.1792412 21.6075653,14.6608845 21.7563993,15.1754392 C22.4296959,16.0188845 23.23588,17.5766944 23.6469453,17.8171736 C24.1395149,18.1708194 24.0208021,18.2733767 23.8613371,18.6004991 C23.5955621,19.1486502 22.6086511,21.5286867 20.7287361,23.1642987 C20.560412,23.3517309 19.4813656,24.5488221 19.3661964,24.6814393 C18.1790682,26.044744 17.2648023,27.1781789 16.8519652,27.8677883 C16.8519652,27.8677883 16.7722327,28.0569888 16.6393452,27.9827232 C16.3735703,27.8430331 15.1350589,26.9624549 14.5946498,26.6954523 C13.3951188,26.1013273 13.2675468,25.5637857 13.2675468,25.5637857 C13.4837104,24.6283924 14.8232163,22.7770565 17.1567205,20.250257 C17.5819605,19.7922856 18.4164939,18.4855642 18.4714207,18.3794705 C18.5724152,18.1867335 18.0763019,17.7552856 17.9629046,17.6279731 C17.2736615,16.8428793 17.066357,16.1568064 14.167638,12.6610173 C13.5368654,11.9006787 13,11.5682517 13,11.3507595 C13,11.3507595 14.0737309,10.5090824 14.125114,10.4560355 C14.7665176,9.81240008 16.0138882,9.31906414 16.5170888,9.05913445"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiperPrev);
export default __webpack_public_path__ + "static/media/swiper-prev.927f1b188edc1e8137b1506efdd5f9e8.svg";
export { ForwardRef as ReactComponent };